import { createTheme } from '@mui/material/styles';

// Etisalat brand colors
const etisalatColors = {
  primary: '#D32F2F',      // Etisalat Red
  primaryDark: '#B71C1C',  // Darker Red
  primaryLight: '#EF5350', // Lighter Red
  secondary: '#424242',    // Dark Gray
  background: '#F5F5F5',   // Light Gray
  white: '#FFFFFF',
  black: '#000000',
  textPrimary: '#212121',
  textSecondary: '#757575',
  success: '#5ca15f',      // Green for ACTIVE badges
  warning: '#FF9800',
  error: '#F44336',
  info: '#2196F3',
};

const theme = createTheme({
  palette: {
    primary: {
      main: etisalatColors.primary,
      dark: etisalatColors.primaryDark,
      light: etisalatColors.primaryLight,
      contrastText: etisalatColors.white,
    },
    secondary: {
      main: etisalatColors.secondary,
      contrastText: etisalatColors.white,
    },
    background: {
      default: etisalatColors.background,
      paper: etisalatColors.white,
    },
    text: {
      primary: etisalatColors.textPrimary,
      secondary: etisalatColors.textSecondary,
    },
    success: {
      main: etisalatColors.success,
      light: 'rgba(127, 219, 131, 0.22)',
      contrastText: '#1b5e20',
    },
    warning: {
      main: etisalatColors.warning,
    },
    error: {
      main: etisalatColors.error,
    },
    info: {
      main: etisalatColors.info,
    },
  },
  typography: {
    fontFamily: [
      'SuisseIntl',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 600,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8, // Default border radius for rounded corners
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 6, // Rounded buttons
          fontWeight: 500,
          padding: '8px 16px',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        outlined: {
          borderWidth: 1,
          '&:hover': {
            borderWidth: 1,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8, // Rounded panels
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        },
        elevation1: {
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8, // Rounded cards
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 4, // Slightly rounded chips
          fontWeight: 500,
          fontSize: '0.75rem',
        },
        colorSuccess: {
          backgroundColor: 'rgba(92, 161, 95, 0.22)',
          color: '#5ca15f',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          fontSize: '0.875rem',
          minHeight: 48,
          padding: '12px 16px',
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid #E0E0E0',
        },
        indicator: {
          height: 3,
          borderRadius: '3px 3px 0 0',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '16px',
        },
        head: {
          fontWeight: 600,
          backgroundColor: '#FAFAFA',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          borderRadius: 0, // Remove rounded corners from AppBar
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        },
      },
    },
  },
});

export default theme;
